module.exports = __webpack_public_path__ + "img/bg-cta3.471f5652.jpg";